import { render } from "./MenuTabs.vue?vue&type=template&id=60f301c0"
import script from "./MenuTabs.vue?vue&type=script&lang=js"
export * from "./MenuTabs.vue?vue&type=script&lang=js"

import "./MenuTabs.vue?vue&type=style&index=0&id=60f301c0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__